module.exports = __webpack_public_path__ + "img/connect-line-rule.5f6f14bf.svg";